import { styled } from "@mui/material";
import { MultiSectionDigitalClock } from "@mui/x-date-pickers";

const CustomizedStaticDigitalTime = styled(MultiSectionDigitalClock)(
    ({ theme }) => `
        .MuiMultiSectionDigitalClockSection-root {
            height: 100%;
            max-height: 100%;
        }
    `)

export { CustomizedStaticDigitalTime }